import { Phone, Search, Home, Users, FileText, BookOpen } from 'lucide-react';
import { IDX_SEARCH_URL } from './site';
import { scrollToSection } from '../utils/scroll';

const internal = (label, href, sub) => ({ label, href, type: 'link', internal: true, sub });

export const NAV_ITEMS = [
  { label: 'Home', action: () => scrollToSection('home'), type: 'scroll', icon: Home },
  { label: 'Search', href: IDX_SEARCH_URL, type: 'link', icon: Search },
  {
    label: 'Buyers', href: IDX_SEARCH_URL, type: 'link', icon: Users,
    children: [
      { label: 'Search All Homes', href: IDX_SEARCH_URL, type: 'link', sub: 'Live MLS listings in VA & NC' },
      internal('PCS Housing Guide', '/pcsing-to-nas-oceana-norfolk', 'NAS Oceana & Naval Station Norfolk'),
      internal('VA Loan Guide (2026)', '/va-loan-guide', 'Zero down, no PMI, state programs'),
    ],
  },
  {
    label: 'Sellers', href: '/home-value', type: 'link', internal: true, icon: FileText,
    children: [
      internal('Free Home Valuation', '/home-value', 'What is your home worth?'),
      internal('23454 Home Values', '/sell/23454', 'Ocean Lakes, Red Mill & Strawbridge'),
      internal('Sandbridge Spotlight', '/sandbridge', 'Virginia Beach oceanfront'),
      internal("Chick's Beach Spotlight", '/chicks-beach', 'Chesapeake Bay waterfront'),
      internal('Great Neck Spotlight', '/great-neck', 'Lynnhaven River & Cox schools'),
      internal('North End Spotlight', '/north-end', '42nd to 89th Street'),
      internal('Corolla Spotlight', '/corolla', 'Outer Banks, NC'),
      internal('Duck Spotlight', '/duck', 'Outer Banks, NC'),
      internal('Nags Head Spotlight', '/nags-head', 'Outer Banks, NC'),
    ],
  },
  { label: 'Blog', href: '/blog', type: 'link', internal: true, icon: BookOpen },
  { label: 'Open House', href: '/open-house', type: 'link', internal: true, icon: Home },
  { label: 'Contact Jess', action: () => scrollToSection('contact'), type: 'scroll', icon: Phone },
];

// Flattens dropdown children into the list (for mobile / quick menus).
export const flattenNavItems = (items) =>
  items.flatMap((item) =>
    item.children
      ? [item, ...item.children.map((c) => ({ ...c, icon: item.icon, nested: true }))]
      : [item],
  );
